import { FC } from 'react';
import { Dialog, DialogTitle, DialogContent, Alert, Grid, Typography, DialogActions, Button } from '@mui/material';
import { Product, FailedProductResponse } from '@models';

type Props = {
  open: boolean;
  onClose: () => void;
  result: {
    createdProducts: Product[];
    failedProducts: FailedProductResponse[] | Product[];
  };
  onErrorTryAgain: () => void;
};

const ProductUploadResultModal: FC<Props> = ({
  open,
  onClose,
  result = {
    createdProducts: [],
    failedProducts: [],
  },
  onErrorTryAgain,
}) => {
  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>Upload summary</DialogTitle>
      <DialogContent>
        <Grid container>
          {result.createdProducts?.length > 0 && (
            <Grid item xs={12}>
              <Alert severity="success">In total {result.createdProducts.length} uploaded successfully</Alert>
            </Grid>
          )}
          {result.failedProducts?.length > 0 && (
            <>
              <Grid item xs={12}>
                <Alert severity="error">In total {result.failedProducts.length} failed to upload</Alert>
              </Grid>
              {result.failedProducts.map((item: FailedProductResponse | Product) => (
                <Grid item xs={12} key={item.name}>
                  <Alert severity="warning">
                    <Typography variant="subtitle1">{item.name}</Typography>
                    {item.message ?? '500 Internal error, try again'}
                  </Alert>
                </Grid>
              ))}
            </>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        {result.failedProducts.length > 0 && (
          <Button onClick={onErrorTryAgain} data-testid="retry-failed-products-btn">
            Retry failed products
          </Button>
        )}
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductUploadResultModal;
